<template>
    <div>
        <div v-for="(item, idx) in params.value" :key="idx">{{ item }}</div>
    </div>
</template>

<script>
    export default {};
</script>
